import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { isLkOilgasforumUrl } from '@/shared/lib/utils/utm/append-utm-to-lk-url';
import { applyUtmParamsToLkAnchor, applyUtmParamsToLkLinks } from '@/shared/lib/utils/utm/apply-utm-to-lk-links';

function getLkAnchorFromEventTarget(target: EventTarget | null): HTMLAnchorElement | null {
    if (!(target instanceof Element)) {
        return null;
    }

    const anchor = target.closest('a[href]');
    if (!(anchor instanceof HTMLAnchorElement)) {
        return null;
    }

    const href = anchor.getAttribute('href');
    if (!href || !isLkOilgasforumUrl(href)) {
        return null;
    }

    return anchor;
}

export const useApplyUtmToLkLinks = () => {
    const router = useRouter();

    useEffect(() => {
        const apply = () => {
            applyUtmParamsToLkLinks();
        };

        apply();

        const onNewPageReady = () => {
            apply();
        };

        const onRouteChangeComplete = () => {
            apply();
        };

        const onPointerOrClick = (event: Event) => {
            const anchor = getLkAnchorFromEventTarget(event.target);
            if (anchor) {
                applyUtmParamsToLkAnchor(anchor);
            }
        };

        document.addEventListener('new-page-ready', onNewPageReady);
        router.events.on('routeChangeComplete', onRouteChangeComplete);
        document.addEventListener('mousedown', onPointerOrClick, true);
        document.addEventListener('click', onPointerOrClick, true);

        return () => {
            document.removeEventListener('new-page-ready', onNewPageReady);
            router.events.off('routeChangeComplete', onRouteChangeComplete);
            document.removeEventListener('mousedown', onPointerOrClick, true);
            document.removeEventListener('click', onPointerOrClick, true);
        };
    }, [router.events]);
};
